import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Avatar,
  Link,
  IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { COLORS } from "../../constants";

const DesktopTeam = ({
  heading,
  description,
  teamInfo,
  selectedTeam,
  handleTeamSelect,
  selectedTeamData,
}) => (
  <Grid
    container
    spacing={3}
    sx={{ flexDirection: { xs: "column", md: "row" }, my: 1 }}
  >
    <Grid item xs={12} md={3.8}>
      <Box
        sx={{
          borderRadius: "2px",
          height: "100%",
        }}
      >
        <Typography
          sx={{
            paddingLeft: 0,
            fontSize: "var(--font-size-xxl)",
            fontWeight: 500,
            lineHeight: "var(--spacing-xxl)",
            color: COLORS.darkText,
          }}
        >
          {heading}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: COLORS.lightText,
            mb: 2,
            lineHeight: 1.8,
            mt: 3,
            fontSize: "var(--font-size-s)",
          }}
        >
          {description}
        </Typography>

        <Box
          sx={{
            display: "inline-block",
            flexDirection: "column",
            gap: 1,
            mt: 2,
          }}
        >
          {teamInfo.map((team) => (
            <Button
              key={team.title}
              onClick={() => handleTeamSelect(team.title)}
              sx={{
                px: 2,
                py: 1,
                mr: 1,
                my: 1,
                backgroundColor:
                  selectedTeam === team.title ? COLORS.themeRed : COLORS.white,
                border: `1px solid ${COLORS.border}`,
                borderRadius: "99px",
                fontSize: "var(--font-size-xs)",
                color:
                  selectedTeam === team.title ? COLORS.white : COLORS.lightText,
                textTransform: "none",
                justifyContent: "flex-start",
                "&:hover": {
                  backgroundColor:
                    selectedTeam === team.title
                      ? COLORS.themeRed
                      : COLORS.border,
                },
              }}
            >
              {team.title}
            </Button>
          ))}
        </Box>
      </Box>
    </Grid>
    <Grid item xs={12} md={8.2}>
      <Grid container spacing={2}>
        {selectedTeamData?.members.map((member) => (
          <Grid item xs={12} sm={4} key={member.name}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                backgroundColor: COLORS.white,
                border: `1px solid ${COLORS.border}`,
                borderRadius: "2px",
                p: 2,
                height: "100%",
                boxSizing: "border-box",
              }}
            >
              <Avatar
                alt={member.name}
                src={member.image}
                sx={{ width: 150, height: 150, mb: 2 }}
              />
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Typography
                  sx={{
                    color: COLORS.darkText,
                    textTransform: "capitalize",
                    fontSize: "var(--font-size-xs)",
                    fontWeight: 500,
                  }}
                >
                  {member.name}
                </Typography>
                {selectedTeam !== "Management" && member.linkedin && (
                  <IconButton
                    sx={{ color: COLORS.themeBlue, ml: 0 }}
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener"
                  >
                    <LinkedInIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              {member.role && (
                <Typography
                  variant="body2"
                  sx={{ color: COLORS.lightText, mb: 1 }}
                >
                  {member.role}
                </Typography>
              )}
              {selectedTeam !== "Management" && member.email && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 1,
                    maxWidth: "100%",
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton sx={{ color: COLORS.gray }}>
                      <EmailIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Link
                    href={`mailto:${member.email}`}
                    sx={{
                      color: COLORS.darkText,
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                      fontSize: "0.875rem",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      flex: 1,
                    }}
                  >
                    {member.email}
                  </Link>
                </Box>
              )}
              {selectedTeam !== "Management" && member.phone && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 1,
                    maxWidth: "100%",
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton sx={{ color: COLORS.gray }}>
                      <PhoneIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Link
                    href={`tel:${member.phone}`}
                    sx={{
                      color: COLORS.darkText,
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                      fontSize: "0.875rem",
                      flex: 1,
                    }}
                  >
                    {member.phone}
                  </Link>
                </Box>
              )}
              {selectedTeam !== "Management" && member.whatsapp && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    maxWidth: "100%",
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton sx={{ color: COLORS.gray }}>
                      <WhatsAppIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Link
                    href={`https://wa.me/${member.whatsapp}`}
                    sx={{
                      color: COLORS.darkText,
                      textDecoration: "none",
                      "&:hover": { textDecoration: "underline" },
                      fontSize: "0.875rem",
                      flex: 1,
                    }}
                  >
                    {member.whatsapp}
                  </Link>
                </Box>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Grid>
  </Grid>
);

export default DesktopTeam;
